import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable, OnDestroy } from '@angular/core';
import { BaseRestService } from './base-rest.service';
import { IOrganisationList, Organisation } from '../models/organisations';
import { SubjectTypeService } from './subject-type.service';
import { SubjectType } from '../models/subject-type';
import { AutoUnsubscribe } from 'auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Injectable({ providedIn: 'root'})
export class OrganisationService extends BaseRestService<Organisation, IOrganisationList> implements OnDestroy{
  constructor(http: HttpClient, protected router: Router, private subjectTypeService: SubjectTypeService) {
    super(OrganisationService, http, 'api/organisations', 'organisation', router);

    // enable caching
    this.cacheEnabled = true;
  }

  ngOnDestroy(): void { }

  get showOrganisations(): boolean{
    const cachedData = this.getCache();
    return ((cachedData.length > 0) && (cachedData.filter((i) => !i.hideRecord).length > 1));
  }

  organisationLabel(subjectTypeName?: string): string{
    let subjectTypes = this.subjectTypeService.getCache().filter((i) => !i.hideRecord);
    if (subjectTypeName){
      subjectTypes = subjectTypes.filter((i) => i.name.toLowerCase() === subjectTypeName.toLowerCase());
    }
    if (subjectTypes.length > 0){
      const dataFields = [];
      subjectTypes.map((i) => {
        dataFields.push(...i.dataFields.filter((x) => (x.dataType.toLowerCase() === 'organisation')));
      });
      if (dataFields.length > 0){
        return dataFields[0].label;
      }
    }
    return 'Organisation';
  }

  hasOrganisation(subjectType?: SubjectType): boolean{
    const entity = subjectType ? subjectType.dataFields.find((i) => i.dataType.toLowerCase() === 'organisation') : null;
    return entity ? true : false;
  }

  public getName(id: number): any {
    const item = this.getCache().find((i) => id === i.id );
    return (item != null) ? item.name : '';
  }

}
